const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const FAVORITES = {
    FAVORITE: `${API_BASE_URL}/favorites/favorite/`,
    ALL_FAVORITES: `${API_BASE_URL}/favorites/favorites/`, // Get all favorited freelancers
};

export default FAVORITES;